export default "__VITE_ASSET__CXw4ij$B__"